import {createRouter, createWebHistory} from 'vue-router';
import HomeView from '../views/HomeView.vue'
import WurfDetailView from '../views/WurfDetailView.vue'
import KittenDetailView from '../views/KittenDetailView.vue'

// Navbar
import CatteryView from '../views/CatteryView.vue'
// Not used in the routes themselves, just within WurfDetailView
//import WuerfeView from '../views/WuerfeView.vue'
import AktuellesView from '../views/AktuellesView.vue'
import CrewDetailView from '../views/CrewDetailView.vue'

// Footer
import ZuchtfreundeView from '../views/ZuchtfreundeView.vue'
import WissenswertesView from '../views/WissenswertesView.vue'
import DokumenteView from '../views/DokumenteView.vue'
import ImpressumView from '../views/ImpressumView.vue'
import DatenschutzView from '../views/DatenschutzView.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomeView
    },
    {
        path: '/wuerfe/:wurf?',
        name: 'Wurf',
        component: WurfDetailView,
        props: true,
    },
    {
        path: '/kitten/:kitten?',
        name: 'Kitten Details',
        component: KittenDetailView,
        props: true,
    },
    // Navbar
    {
        path: '/cattery',
        name: 'Unsere Cattery',
        component: CatteryView
    },
/*
    {
        path: '/wuerfe',
        name: 'Würfe',
        component: WuerfeView
    },
*/
    {
        path: '/aktuelles',
        name: 'Aktuelles',
        component: AktuellesView
    },
/*
    {
        path: '/crew',
        name: 'Crew',
        component: CrewView
    },
*/
    {
        path: '/crew/:crew?',
        name: 'Crew Details',
        component: CrewDetailView,
        props: true,
    },
    // Footer
    {
        path: '/zuchtfreunde',
        name: 'Zuchtfreunde',
        component: ZuchtfreundeView
    },
    {
        path: '/wissenswertes',
        name: 'Wissenswertes',
        component: WissenswertesView
    },
    {
        path: '/dokumente',
        name: 'Dokumente',
        component: DokumenteView
    },
    {
        path: '/impressum',
        name: 'Impressum',
        component: ImpressumView
    },
    {
        path: '/datenschutz',
        name: 'Datenschutz',
        component: DatenschutzView
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active",
    linkExactActiveClass: "exact-active",
});

export default router;
